module.exports = __webpack_public_path__ + "img/tip.7082c885.png";